import { render, staticRenderFns } from "./CoverTplSelector.vue?vue&type=template&id=aa0c0f16&scoped=true"
import script from "./CoverTplSelector.vue?vue&type=script&lang=js"
export * from "./CoverTplSelector.vue?vue&type=script&lang=js"
import style0 from "./CoverTplSelector.vue?vue&type=style&index=0&id=aa0c0f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0c0f16",
  null
  
)

export default component.exports